var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_1598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9896 0C5.36251 0.00583409 -0.00582934 5.38292 4.75069e-06 12.0105C0.00583884 18.638 5.38293 24.0058 12.0105 24C18.6341 23.9942 24 18.6234 24 11.9998C23.9888 5.3732 18.6166 0.00583409 11.9896 0ZM16.9164 10.8072L16.9062 10.8174L12.239 19.2598C12.1534 19.4207 11.9857 19.5209 11.8033 19.5189H11.658C11.4392 19.4489 11.2943 19.2404 11.3055 19.0109L11.5442 13.9804H7.49924C7.32617 13.9785 7.16573 13.8885 7.07384 13.7417C6.98293 13.5881 6.98293 13.3975 7.07384 13.2439L11.7411 4.73923C11.8534 4.53115 12.0941 4.42808 12.3221 4.49031C12.5389 4.56323 12.6824 4.76986 12.6746 4.99836L12.4466 10.0288H16.4915C16.6709 10.0288 16.8348 10.1285 16.9169 10.2879C17.0249 10.444 17.0249 10.6506 16.9169 10.8067L16.9164 10.8072Z",
    fill: "#249DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_1598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.3a103c9d12a43e17b4710a265cda1da2.svg";
export { ForwardRef as ReactComponent };